<script setup>
// "Require push" block screen (#149): an admin turned it on for this staff
// member, so under notifications-v2 the router sends every page here until this
// install is a reachable push device. Logging out stays one tap away.
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { IconBellRinging, IconLogout } from '@tabler/icons-vue'
import PushSetupSteps from '@/components/PushSetupSteps.vue'
import { usePushReachabilityStore } from '@/stores/pushReachability.js'
import { useAuthStore } from '@/stores/authStore'
import { useWeekStore } from '@/stores/week'
import { api } from '@/services/api'
import { useBottomNavStore } from '@/stores/bottomNavStore'

const reach = usePushReachabilityStore()
const authStore = useAuthStore()
const weekStore = useWeekStore()
const router = useRouter()
const d = __DICT__.notifications

// Nothing to navigate to while blocked.
onMounted(() => useBottomNavStore().setBottomNavVisibility(false))

// Blocked means not a reachable push device here, so there is always a kind.
const kind = computed(() => reach.banner?.kind ?? 'enable')

async function onEnabled() {
  await reach.refresh()
  if (!reach.blocked) router.replace({ name: 'SelectWeek' })
}

// As More > Log out does.
async function logOut() {
  try {
    await api.logout()
  } catch (e) {
    console.warn('[push required] logout request failed', e?.message || e)
  }
  weekStore.isLoading = false
  authStore.setPwaUnlocked(false)
  authStore.setLoggedIn(false)
  authStore.logOut()
  router.push({ name: 'Login' })
}
</script>

<template>
  <div class="page page-center">
    <div class="container container-tight py-4">
      <div class="card">
        <div class="card-body">
          <div class="text-center mb-3">
            <IconBellRinging class="text-primary" :size="40" />
            <h2 class="h2 mt-2 mb-1">{{ d.requiredTitle }}</h2>
            <p class="text-secondary mb-0">{{ d.requiredBody }}</p>
          </div>
          <PushSetupSteps :kind="kind" :open-in-safari="reach.install.openInSafari" @enabled="onEnabled" />
        </div>
        <div class="card-footer">
          <button class="btn btn-ghost-secondary w-100" @click="logOut">
            <IconLogout class="me-2" :size="18" />
            {{ __DICT__.logOut }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
